import { handleActions } from "redux-actions";
import {
  ADD_SAVED_PRODUCT,
  REMOVE_SAVED_PRODUCT,
  RECEIVE_SAVED_ITEMS_SUMMARY
} from "./constants";

const initialState = {
  savedProducts: [],
  summary: []
};

export default handleActions(
  {
    [ADD_SAVED_PRODUCT]: (state, { payload: productId }) => ({
      ...state,
      savedProducts: [...state.savedProducts, productId]
    }),
    [REMOVE_SAVED_PRODUCT]: (state, { payload: productId }) => {
      const productIdIndex = state.savedProducts.indexOf(productId);

      if (productIdIndex === -1) {
        return { ...state };
      }

      return {
        ...state,
        savedProducts: [
          ...state.savedProducts.slice(0, productIdIndex),
          ...state.savedProducts.slice(productIdIndex + 1)
        ]
      };
    },
    [RECEIVE_SAVED_ITEMS_SUMMARY]: (state, { payload: productIds }) => ({
      ...state,
      summary: productIds
    })
  },
  initialState
);
